import React from 'react';

import { Stack, Switch, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';

import type { Control } from 'react-hook-form';

import TextFieldComp from '@/components/TextFieldComp';
import TimeFieldComp from '@/components/TimeFieldComp';

/**
 * MealInputType
 */
export type MealInputType = {
  /** 昨日で登録 */
  isYesterday: boolean,
  /** 食事 */
  mealContent: string,
  /** 測定日時 */
  measureDateTime: string,
}

/**
 * MealFormInputType
 */
export type MealFormInputType = {
  /** コントロール */
  control: Control<MealInputType, never>,
  /** エラー */
  errors: any,
}

const MealFormInput: React.FC<MealFormInputType> = ({ control, errors }) => (
  <div>
    <div style={{ margin: '10px 0' }}>
      <Controller
        render={({ field }) => (
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <Switch defaultChecked={field.value} onChange={field.onChange} />
            <Typography>昨日の食事で登録</Typography>
          </Stack>
        )}
        name="isYesterday"
        control={control as any}
      />
    </div>
    <TextFieldComp
      type="text"
      control={control}
      rules={{
        required: '必須項目です',
      }}
      name="mealContent"
      label="食事内容"
      placeholder="カレーライス"
      errors={errors}
      multiline
      rows={5}
    />
    <TimeFieldComp
      control={control}
      name="measureDateTime"
      label="日時"
      rules={{
        required: '必須項目です',
      }}
      errors={errors}
    />
  </div>
);

export default MealFormInput;
